import PropTypes from 'prop-types';
import React from 'react';
import EmployeeFillForm from './EmployeeFillForm';
import RemoteStateTaxV0 from './RemoteStateTaxV0';

function StateTaxVersionAdapter(props) {
  const {
    action,
    onSignedSuccess,
    companyStaff,
    viewResultAsManager,
    prefilledData,
    dataFromEi,
    processData,
    company,
  } = props;
  const innerIsOnboardingV2 = isOnboardingV2 === 'true';

  if (innerIsOnboardingV2) {
    return (
      <EmployeeFillForm
        action={action}
        onSignedSuccess={onSignedSuccess}
        companyStaff={companyStaff}
        viewResultAsManager={viewResultAsManager}
        prefilledData={prefilledData}
        dataFromEi={dataFromEi}
      />
    );
  }

  return (
    <RemoteStateTaxV0
      company={company}
      processData={processData}
      action={action}
      onSignedSuccess={onSignedSuccess}
      viewResultAsManager={viewResultAsManager}
    />
  );
}

StateTaxVersionAdapter.defaultProps = {
  prefilledData: {},
  dataFromEi: {},
  viewResultAsManager: false,
};

StateTaxVersionAdapter.propTypes = {
  company: PropTypes.shape().isRequired, // for new state tax form
  processData: PropTypes.shape().isRequired, // for new state tax form
  action: PropTypes.shape().isRequired,
  companyStaff: PropTypes.shape().isRequired,
  prefilledData: PropTypes.shape(),
  dataFromEi: PropTypes.shape(),
  onSignedSuccess: PropTypes.func.isRequired,
  viewResultAsManager: PropTypes.bool,
};

export default StateTaxVersionAdapter;
